export default __webpack_public_path__ + "static/media/self-service-icon.197514ca.svg";